<template>
  <div class="gird_container">
    <div class="gird_star_yes" :style="'background-color:'+color+';border:1px solid '+color+';'" v-if="score > 0"></div>
    <div class="gird_star_no" :style="'border:1px solid '+color+';'" v-if="score <= 0"></div>
    <div class="gird_star_yes" :style="'background-color:'+color+';border:1px solid '+color+';'" v-if="score > 1"></div>
    <div class="gird_star_no" :style="'border:1px solid '+color+';'" v-if="score <= 1"></div>
    <div class="gird_star_yes" :style="'background-color:'+color+';border:1px solid '+color+';'" v-if="score > 2"></div>
    <div class="gird_star_no" :style="'border:1px solid '+color+';'" v-if="score <= 2"></div>
    <div class="gird_star_yes" :style="'background-color:'+color+';border:1px solid '+color+';'" v-if="score > 3"></div>
    <div class="gird_star_no" :style="'border:1px solid '+color+';'" v-if="score <= 3"></div>
    <div class="gird_star_yes" :style="'background-color:'+color+';border:1px solid '+color+';'" v-if="score > 4"></div>
    <div class="gird_star_no" :style="'border:1px solid '+color+';'" v-if="score <= 4"></div>
  </div>
</template>

<script>
  export default {
    name: "star",
    props:{
      color:{
        type:String,
        value:''
      },
      score:{
        type: Number,
        value: 0
      }
    },
    data(){
      return {

      }
    },
    mounted(){

    },
    methods: {

    }
  }
</script>

<style scoped>
  .gird_container{
    height: 1rem;
    line-height: 1rem;
    width:100%;
  }
  .gird_star_yes {
    width:.9rem;
    height:.9rem;
    float:left;
    border-radius: .2rem;
    background-color: rgb(56, 152, 235);
    margin-right:.3rem;
  }
  .gird_star_no {
    width:.9rem;
    height:.9rem;
    float:left;
    border-radius: .2rem;
    margin-right:.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ship/star.vue